import { render, staticRenderFns } from "./xingshiStatus.vue?vue&type=template&id=3d04b74b&scoped=true&"
import script from "./xingshiStatus.vue?vue&type=script&lang=js&"
export * from "./xingshiStatus.vue?vue&type=script&lang=js&"
import style0 from "./xingshiStatus.vue?vue&type=style&index=0&id=3d04b74b&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d04b74b",
  null
  
)

export default component.exports